





























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SimpleLookupModel, CompanyFollowupStatusModel } from '@/core/models';
import { CompanyService } from '@/core/services';
import { InputSelectCpt, InputTextareaCpt, DialogCpt } from '@/core/components';
import _ from 'lodash';

import AppVue from '@/AppVue.vue';

@Component({
  components: { InputSelectCpt, InputTextareaCpt, DialogCpt },
})
export default class UpdateFollowupStatusDialogCpt extends AppVue {
  @Prop({ default: false }) showDialog: boolean;
  @Prop() companyId: number;
  @Prop() companyName: string;
  @Prop() followUpStatusId: number;

  model = new CompanyFollowupStatusModel();
  loading = false;
  followUpStatus = [] as SimpleLookupModel[];

  get isOpen() {
    return this.showDialog;
  }

  get title() {
    return `Follow-up status - ${this.companyName}`;
  }

  async created() {
    try {
      await this.initializeStatusList();
      await this.initializeModel();
    } finally {
      this.loading = false;
    }
  }

  private dialogOpened() {
    this.model.followUpStatusId = this.followUpStatusId;
  }

  private async initializeStatusList() {
    this.followUpStatus = await CompanyService.getFollowUpStatuses();
  }

  private async initializeModel() {
    const model = await CompanyService.getFollowUpStatus(this.companyId);
    if (model) {
      _.extend(this.model, model);
    }
  }

  private close(saved: boolean = false) {
    this.model.comments = '';
    this.$emit('close', saved);
  }

  private async save() {
    this.loading = true;
    try {
      this.model.companyId = this.companyId;
      await CompanyService.updateFollowUpStatus(this.model);
      this.close(true);
    } catch {
      this.notify('Error', 'Something went wrong on updating the follow-up status.', 'error');
    } finally {
      this.loading = false;
    }
  }
}
